import { SelfServiceContext } from "core";
import { observer } from "mobx-react-lite";
import { KeyboardEvent, useContext } from "react";

const Search = observer(() => {
    const selfServiceContext = useContext(SelfServiceContext);
    const store = selfServiceContext.stores.inbox;

    const search = (e: KeyboardEvent<HTMLInputElement>) => {
        const needle = (e.target as HTMLInputElement).value;
        store.search(needle);
    }

    return <span className="search">
        <input type="text" placeholder="Search Messages" onKeyUp={search} />
        <i className="icon-search" />
    </span>
});

export default Search;